import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Typography, FormHelperText, useTheme, IconButton } from '@mui/material';
import { useState, useEffect } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { CloudArrowUpFilled, DeleteFilled } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
export const FileUpload = ({ onChange, onFileRemove, allowedFileSize, allowedFileTypes, allowedFileTypesText, uploadLabel, error, infoText, multiple, vehicleDetails, setVehicleDetails, imageUrl }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [files, setFiles] = useState([]);
    const [errorText, setErrorText] = useState('');
    const [canUpload, setCanUpload] = useState(true);
    useEffect(() => {
        if (error)
            setErrorText(error);
    }, [error]);
    const fileTypeError = () => {
        const translatedErrorText = t('FileFormatConstraintMessage', {
            format: { allowedFileTypesText }
        });
        setErrorText(translatedErrorText);
        setCanUpload(true);
    };
    const fileSizeError = () => {
        const translatedErrorText = t('FileSizeConstraintMessage', {
            size: { allowedFileSize }
        });
        setErrorText(translatedErrorText);
        setCanUpload(true);
    };
    const handleFileChange = (newFiles) => {
        setErrorText('');
        const fileArray = multiple ? [...files, ...newFiles] : newFiles;
        setFiles(fileArray);
        onChange(fileArray);
    };
    useEffect(() => {
        if (vehicleDetails?.imageUrl) {
            const file = new File([], vehicleDetails.imageUrl, { type: 'application/octet-stream' });
            setFiles([file]);
        }
    }, [vehicleDetails?.imageUrl]);
    useEffect(() => {
        if (imageUrl) {
            const file = new File([], imageUrl || '', { type: 'application/octet-stream' });
            setFiles([file]);
        }
    }, [imageUrl]);
    const handleFileRemove = (fileName) => {
        setFiles([]);
        onChange([]);
        setVehicleDetails((prev) => ({
            ...prev,
            imageName: '',
            imageUrl: ''
        }));
        onFileRemove && onFileRemove(null);
    };
    const fileElement = (f) => (_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 0.3, justifyContent: 'space-between', sx: {
            bgcolor: theme.palette.background.neutral,
            padding: '8px',
            borderRadius: '4px',
            marginBottom: '4px'
        }, children: [_jsx(Typography, { variant: 'body2', color: 'text.primary', sx: { wordBreak: 'break-all' }, children: f.name }), _jsx(IconButton, { onClick: () => handleFileRemove(f.name), size: 'small', color: 'error', children: _jsx(DeleteFilled, { fontSize: 18 }) })] }, f.name));
    return (_jsxs(Grid, { item: true, xs: 12, children: [_jsx(Box, { sx: {
                    // backgroundColor: theme.palette.grey[800],
                    flexDirection: { xs: 'column', md: 'row' }
                }, children: _jsx(FileUploader, { id: 'fileInput', handleChange: handleFileChange, types: allowedFileTypes, disabled: !canUpload, required: true, maxSize: allowedFileSize, onTypeError: fileTypeError, onSizeError: fileSizeError, multiple: multiple, children: _jsx(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', borderRadius: '12px', sx: {
                            cursor: 'pointer',
                            backgroundColor: theme.palette.background.neutral,
                            height: '100%',
                            width: '100%',
                            border: '1px dashed #919EAB33'
                        }, children: _jsx(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 2.5, children: _jsxs("label", { htmlFor: 'fileInput', style: { display: 'contents', cursor: 'pointer' }, children: [_jsx(CloudArrowUpFilled, { fontSize: 40, color: theme.palette.text.disabled }), _jsx(Box, { children: _jsx(Typography, { variant: 'body2', color: 'textDisabled', style: { wordBreak: 'break-all' }, children: uploadLabel }) })] }) }) }) }) }), _jsxs(Box, { mt: 2, children: [files instanceof Array && files.map((f) => fileElement(f)), files instanceof File && fileElement(files)] }), infoText && (_jsx(FormHelperText, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center'
                }, children: infoText })), errorText && (_jsx(FormHelperText, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center'
                }, error: true, children: errorText }))] }));
};
